module.exports = __webpack_public_path__ + "static/media/NIIT.d512a37d.jpeg";